import React, { useState, useEffect } from "react";
import {
  Typography,
  Paper,
  Button,
  Box,
  TextField,
  useMediaQuery,
  useTheme,
  Autocomplete,
  Divider,
  Alert,
} from "@mui/material";
import * as Yup from "yup";
import { carga } from "./Util/ConsumosFactorPeso";
import gasolina from "../../img/Gasolina.jpg";
import routeData from "./Util/Rutas.json";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";

export default function CalculoGasolina() {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const isIpad = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width:600px)");
  const [pesoBruto, setPesoBruto] = useState(); // Valor de ejemplo
  const [modoIdayVuelta, setModoIdayVuelta] = useState("null");
  const [consumoDiesel, setConsumoDiesel] = useState();
  const [ocultarinputs, setOcultarInputs] = useState(false);
  const [rutaActual, setRutaActual] = useState(null);
  const [error, setError] = useState("");
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [factorActual, setFactorActual] = useState(null);
  const [mostrarCampo, setMostrarCampo] = useState(false);
  const [hayruta, setHayruta] = useState(false);
  const [botonesVisibles, setBotonesVisibles] = useState(true);

  useEffect(() => {
    if (rutaActual && pesoBruto) {
      const resultado = calculateFuelConsumption(rutaActual, pesoBruto);
      if (resultado) {
        setConsumoDiesel(resultado.consumo.toFixed(2));
        setFactorActual(resultado.factorInfo["KM / Factor / Galones"]);
      }
    }
  }, [rutaActual, pesoBruto]);

  useEffect(() => {
    if (selectedOrigin && selectedDestination) {
      setHayruta(true);
    } else {
      setHayruta(false);
    }
  }, [selectedOrigin, selectedDestination]);

  const removeCommas = (value) => {
    return value.replace(/,/g, "");
  };

  const getFactor = (peso) => {
    const pesoNum = parseFloat(removeCommas(peso));
    let factorEncontrado;

    if (isNaN(pesoNum) || pesoNum === 0) {
      factorEncontrado = carga.find(
        (item) => item["EQUIPOS ELECTRONICOS"] === "Cabezal Sin Furgón de 0 kg"
      );
    } else if (pesoNum > 0 && pesoNum <= 2999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Cabezal con Furgón Vacío 1 a 2,999.99 kg"
      );
    } else if (pesoNum >= 3000 && pesoNum <= 8000) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Carga liviana de 3,000 a 8,000.00 Kg"
      );
    } else if (pesoNum >= 8001 && pesoNum <= 12999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Carga liviana de 8,001 a 12,999.99 Kg"
      );
    } else if (pesoNum >= 13001 && pesoNum <= 17999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Carga liviana de 13,001 a 17,999.99 Kg"
      );
    } else if (pesoNum >= 18000 && pesoNum <= 21000) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Cargado de 18,000 a 21,000.00 Kg"
      );
    } else if (pesoNum >= 21001 && pesoNum <= 23999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Peso de 21,001 a 23,999.99 Kg"
      );
    } else if (pesoNum >= 24000 && pesoNum <= 26999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Pesado de 24,000 a 26,999.99 Kg"
      );
    } else if (pesoNum >= 27000) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Sobre Peso de 27,000 a 30,000 kg"
      );
    }
    return factorEncontrado;
  };

  const calculateFuelConsumption = (rutaActualParam, pesoBrutoParam) => {
    if (!rutaActualParam || !pesoBrutoParam) return null;

    const factorInfo = getFactor(pesoBrutoParam);
    if (factorInfo) {
      const kilometraje = rutaActualParam.kilometraje;
      const consumo = kilometraje / factorInfo["KM / Factor / Galones"];
      return { consumo, factorInfo };
    }
    return null;
  };

  const calculateFuelConsumptionSoloCabezal = (rutaActualParam) => {
    if (!rutaActualParam) return null;

    const factorInfo = carga.find(
      (item) => item["EQUIPOS ELECTRONICOS"] === "Cabezal Sin Furgón de 0 kg"
    );
    if (factorInfo) {
      const kilometraje = rutaActualParam.kilometraje;
      const consumo = kilometraje / factorInfo["KM / Factor / Galones"];
      return { consumo, factorInfo };
    }
    return null;
  };

  const calculateFuelConsumptionFurgonVacio = (rutaActualParam) => {
    if (!rutaActualParam) return null;

    const factorInfo = carga.find(
      (item) =>
        item["EQUIPOS ELECTRONICOS"] ===
        "Cabezal con Furgón Vacío 1 a 2,999.99 kg"
    );
    if (factorInfo) {
      const kilometraje = rutaActualParam.kilometraje;
      const consumo = kilometraje / factorInfo["KM / Factor / Galones"];
      return { consumo, factorInfo };
    }
    return null;
  };

  const handleDestinationChange = async (event, newValue) => {
    await validateRoute(selectedOrigin, newValue);
    setSelectedDestination(newValue);

    if (newValue && selectedOrigin) {
      const rutasEncontradas = routeData.filter(
        (ruta) =>
          (ruta.origen === selectedOrigin && ruta.destino === newValue) ||
          (ruta.origen === newValue && ruta.destino === selectedOrigin)
      );
      const rutaOptima = rutasEncontradas.reduce((prev, current) =>
        prev.kilometraje < current.kilometraje ? prev : current
      );
      setRutaActual(rutaOptima || null);
    } else {
      setRutaActual(null);
    }
  };

  // Schema de validación para la ruta completa
  const routeValidationSchema = Yup.object().shape({
    origin: Yup.string()
      .required("Debe seleccionar una ciudad de origen")
      .nullable(),
    destination: Yup.string()
      .required("Debe seleccionar una ciudad de destino")
      .nullable()
      .test(
        "valid-route",
        "No existe una ruta directa entre estas ciudades",
        function (value) {
          const { origin } = this.parent;
          if (!origin || !value) return true;
          return routeData.some(
            (route) =>
              (route.origen === origin && route.destino === value) ||
              (route.origen === value && route.destino === origin)
          );
        }
      ),
  });

  const handlePesoBrutoChange = (event) => {
    let value = event.target.value;

    // Permitir borrar números
    if (value.length < (pesoBruto || "").length) {
      setPesoBruto(value);
      setError("");
      return;
    }

    // No permitir más entrada si ya llegó al límite de 35,999.99
    if (pesoBruto === "35,999.99") {
      return;
    }

    // Permitir solo números, punto decimal y comas
    if (!/^[\d,.]*(\.?\d{0,2})?$/.test(value)) {
      return;
    }

    // Remover comas para validar el número
    const numeroSinFormato = value.replace(/,/g, "");

    // Verificar que el número no exceda 35,999.99
    const numero = parseFloat(numeroSinFormato);
    if (numero > 35999.99) {
      setPesoBruto("35,999.99");
      setError("El valor no puede exceder 35,999.99");
      return;
    }

    // Aplicar formato de miles a la parte entera
    let [entero, decimal = ""] = numeroSinFormato.split(".");
    let formattedEntero = entero;

    // Agregar punto decimal automáticamente después de los primeros 5 números
    if (entero.length > 5) {
      formattedEntero = `${entero.slice(0, 5)}.${entero.slice(5)}`;
    } else if (entero.length === 5 && !decimal) {
      formattedEntero = `${entero}.`;
    }

    // Aplicar formato de miles a la parte entera
    formattedEntero = formattedEntero.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Reconstruir el valor formateado con hasta 2 decimales
    const finalValue = decimal
      ? `${formattedEntero}.${decimal.slice(0, 2)}`
      : formattedEntero;

    setPesoBruto(finalValue);
    setError("");
  };

  const validateRoute = async (origin, destination) => {
    try {
      await routeValidationSchema.validate(
        { origin, destination },
        { abortEarly: false }
      );
      setValidationErrors({});
      return true;
    } catch (err) {
      const errors = {};
      err.inner.forEach((error) => {
        errors[error.path] = error.message;
      });
      setValidationErrors(errors);
      return false;
    }
  };

  const [isAutocompleteDisabled, setIsAutocompleteDisabled] = useState(false);

  const uniqueOrigins = [
    ...new Set([
      ...routeData.map((ruta) => ruta.origen),
      ...routeData.map((ruta) => ruta.destino),
    ]),
  ].sort();

  const availableDestinations = selectedOrigin
    ? [
        ...new Set([
          ...routeData
            .filter(
              (ruta) =>
                ruta.origen === selectedOrigin ||
                ruta.destino === selectedOrigin
            )
            .map((ruta) =>
              ruta.origen === selectedOrigin ? ruta.destino : ruta.origen
            ),
        ]),
      ].sort()
    : [];

  const handleButtonClick = (modo) => {
    setModoIdayVuelta(modo);
    setMostrarCampo(modo !== "solocabezal" && modo !== "vacio");
    setIsAutocompleteDisabled(true);
    setHayruta(false);
    setBotonesVisibles(false); // Esto hará que los botones desaparezcan

    if (modo === "solocabezal" && rutaActual) {
      const resultado = calculateFuelConsumptionSoloCabezal(rutaActual);
      if (resultado) {
        setConsumoDiesel(resultado.consumo.toFixed(2));
        setFactorActual(resultado.factorInfo["KM / Factor / Galones"]);
      }
    } else if (modo === "vacio" && rutaActual) {
      const resultado = calculateFuelConsumptionFurgonVacio(rutaActual);
      if (resultado) {
        setConsumoDiesel(resultado.consumo.toFixed(2));
        setFactorActual(resultado.factorInfo["KM / Factor / Galones"]);
      }
    }
  };

  return (
    <div>
      <div className="flex flex-col items-center justify-center w-full bg-cover bg-center bg-no-repeat bg-[#8cb46d]">
        <br />
        <div className="flex items-center">
          <img
            src={gasolina}
            alt="Tanque de Gasolina"
            className="w-16 h-16 mr-4 rounded-2xl"
          />
          <Typography
            variant={isLargeScreen ? "h3" : "h6"}
            className="text-white font-bold text-center"
            style={{ fontSize: isMobile ? "17px" : "h3" }}
          >
            Calcular Consumo de Combustible 
          </Typography>
        </div>
        <br />
      </div>
      <div
        className={`grid grid-cols-1 ${
          isIpad ? "gap-2" : "md:grid-cols-2 gap-4"
        } w-full p-4 bg-white rounded-lg`}
      >
        {!ocultarinputs && (
          <div>
            <div className="col-span-1">
              <Typography
                variant="h5"
                className="text-center text-gray-800 font-bold"
              >
                INGRESE LA INFORMACIÓN
              </Typography>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <Box>
                  <Autocomplete
                    className="mt-4"
                    options={uniqueOrigins}
                    value={selectedOrigin}
                    disabled={isAutocompleteDisabled}
                    onChange={(event, newValue) => {
                      setSelectedOrigin(newValue);
                      setSelectedDestination(null);
                      setRutaActual(null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Ciudad  Origen"
                        error={!!validationErrors.origin}
                        helperText={validationErrors.origin}
                      />
                    )}
                  />
                </Box>
                <Box>
                  <Autocomplete
                    className="mt-4"
                    options={availableDestinations}
                    value={selectedDestination}
                    onChange={handleDestinationChange}
                    disabled={!selectedOrigin || isAutocompleteDisabled}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Ciudad Destino"
                        error={!!validationErrors.destination}
                        helperText={validationErrors.destination}
                      />
                    )}
                  />
                </Box>
              </div>
              <div className="col-span-1"
              >
              <Typography
                variant="h6"
                className="text-center text-gray-800 font-bold"
              style={{marginTop: "20px"}}>
                INDIQUE EL TIPO DE RECORRIDO
              </Typography>
              </div>
              {botonesVisibles && (
                <div className="flex flex-col md:flex-row justify-between mt-8 mb-8 space-y-2 md:space-y-0 md:space-x-2">
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#3399fe",
                      color: "#fff",
                    }}
                    className="w-full md:w-auto rounded-lg hover:shadow-lg transition duration-200 ease-in-out"
                    onClick={() => handleButtonClick("cargado")}
                    disabled={!selectedOrigin || !selectedDestination}
                  >
                    Flete Cargado
                  </Button>
                  <Button
                     variant="contained"
                     sx={{
                       backgroundColor: "#339967",
                       color: "#fff",
                     }}
                    className="w-full md:w-auto rounded-lg hover:shadow-lg transition duration-200 ease-in-out"
                    onClick={() => handleButtonClick("vacio")}
                    disabled={!selectedOrigin || !selectedDestination}
                  >
                    Furgon Vacio
                  </Button>
                  <Button
                     variant="contained"
                     sx={{
                       backgroundColor: "#00ccff",
                       color: "#000",
                     }}
                    className="w-full md:w-auto rounded-lg hover:shadow-lg transition duration-200 ease-in-out"
                    onClick={() => handleButtonClick("solocabezal")}
                    disabled={!selectedOrigin || !selectedDestination}
                  >
                    Solo Cabezal
                  </Button>
                </div>
              )}

              {mostrarCampo && (
                <div className="space-y-4">
                  <Box mt={4}>
                    <TextField
                      label="Peso Bruto en Carga"
                      variant="outlined"
                      fullWidth
                      type="text"
                      value={pesoBruto}
                      onChange={handlePesoBrutoChange}
                      error={!!error}
                      helperText={error}
                    />
                  </Box>
                </div>
              )}
            </div>

            {consumoDiesel && (
              <div className="col-span-1 mt-2">
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#0d6eff", color: "#fff" }}
                  className="w-full rounded-lg hover:shadow-lg transition duration-200 ease-in-out"
                  onClick={() => setOcultarInputs(!ocultarinputs)}
                >
                  {ocultarinputs
                    ? "Atras"
                    : "Obtener Información"}
                </Button>
              </div>
            )}
          </div>
        )}

        <div className="col-span-1 rounded-lg mt-2">
          <Box className="p-2">
            {ocultarinputs ? (
              <div>
                <div className="flex items-center">
                  <div>
                    <Typography variant="h5">Consumo Diesel</Typography>
                    <Typography variant="h4">
                      {consumoDiesel} galones
                    </Typography>
                  </div>
                </div>
                <Divider className="mb-4" />
                <div className="bg-purple-50 p-4 rounded-lg shadow-sm"></div>
                <div className="col-span-1">
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#0d6eff", color: "#fff" }}
                    className="w-full rounded-lg hover:shadow-lg transition duration-200 ease-in-out"
                    onClick={() => setOcultarInputs(!ocultarinputs)}
                  >
                    {ocultarinputs
                      ? "Atras"
                      : "Mostrar Consumo Diesel"}
                  </Button>
                </div>
              </div>
            ) : (
              <div>
                {isLargeScreen && (
                  <div
                    className={`flex flex-col items-center justify-start h-full ${
                      isIpad ? "mt-4" : ""
                    }`}
                  >
                    <LocalGasStationIcon
                      style={{ fontSize: "50px", margin: "10px" }}
                      className="text-gray-600"
                    />
                    <Typography
                      variant="h6"
                      className="text-gray-800 font-bold mb-4"
                    >
                      No hay detalles de Galones agregados
                    </Typography>
                  </div>
                )}
              </div>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
}
